// src/monsterData.js

export const MonsterData = {
    // Tier 0: Forest & Basic Creatures (for unarmed combat 1-2 damage)
    'slime': {
        key: 'slime',
        name: 'Slime (Basic)',
        tier: 0,
        img: 'monsters/slimeMonster.png',
        description: 'A gelatinous blob, slow but persistent. Found in forests and shallow caves.',
        stats: { health: 8, minDamage: 1, maxDamage: 2, hitChance: 0.6, defense: 0, xp: 5 },
        lootTable: { 'slimeGel': { chance: 0.8, quantity: [1, 3] }, 'gold': { chance: 0.5, quantity: [1, 5] } }
    },
    'forestBat': {
        key: 'forestBat',
        name: 'Forest Bat',
        tier: 0,
        img: 'monsters/forestBatMonster.png',
        description: 'Small, agile nocturnal creatures. Easy to defeat, but can be annoying in groups.',
        stats: { health: 5, minDamage: 1, maxDamage: 2, hitChance: 0.7, defense: 0, xp: 3 },
        lootTable: { 'batWing': { chance: 0.6, quantity: [1, 2] }, 'batFangs': { chance: 0.3, quantity: [1, 1] }, 'gold': { chance: 0.2, quantity: [1, 3] } }
    },
    'wildBoar': {
        key: 'wildBoar',
        name: 'Wild Boar',
        tier: 0,
        img: 'monsters/wildBoarMonster.png',
        description: 'Aggressive, charges at players. Slightly tougher than slimes.',
        stats: { health: 12, minDamage: 2, maxDamage: 3, hitChance: 0.7, defense: 0, xp: 8 },
        lootTable: { 'rawMeat': { chance: 0.7, quantity: [1, 2] }, 'coarseHide': { chance: 0.4, quantity: [1, 1] }, 'boarTusk': { chance: 0.3, quantity: [1, 1] }, 'bone': { chance: 0.5, quantity: [1, 2] } }
    },
    'wolfPup': {
        key: 'wolfPup',
        name: 'Dire Wolf Pup',
        tier: 0,
        img: 'monsters/wolfPupMonster.png',
        description: 'Faster and more damaging than other basic creatures. Attacks in small packs.',
        stats: { health: 10, minDamage: 2, maxDamage: 4, hitChance: 0.75, defense: 0, xp: 10 },
        lootTable: { 'wolfPelt': { chance: 0.5, quantity: [1, 1] }, 'wolfFangs': { chance: 0.4, quantity: [1, 2] }, 'rawMeat': { chance: 0.6, quantity: [1, 1] }, 'toughHide': { chance: 0.3, quantity: [1, 1] } }
    },

    // Tier 1: Copper & Cave Dwellers (for wooden weapons 5-7 damage)
    'goblinBasic': {
        key: 'goblinBasic',
        name: 'Goblin Scout',
        tier: 1,
        img: 'monsters/goblinMonster.png',
        description: 'A common goblin often found scouting or in small groups.',
        stats: { health: 20, minDamage: 3, maxDamage: 5, hitChance: 0.65, defense: 1, xp: 12 },
        lootTable: { 'goblinEar': { chance: 0.5, quantity: [1, 1] }, 'wood': { chance: 0.2, quantity: [1, 1] }, 'gold': { chance: 0.6, quantity: [2, 8] } }
    },
    'goblinWarrior': {
        key: 'goblinWarrior',
        name: 'Goblin Warrior',
        tier: 1,
        img: 'monsters/goblinMonster1.png',
        description: 'Slightly tougher goblins, armed with crude weapons.',
        stats: { health: 25, minDamage: 3, maxDamage: 6, hitChance: 0.7, defense: 2, xp: 15 },
        lootTable: { 'goblinEar': { chance: 0.6, quantity: [1, 2] }, 'wood': { chance: 0.3, quantity: [1, 1] }, 'gold': { chance: 0.7, quantity: [3, 10] } }
    },
    'giantSpider': {
        key: 'giantSpider',
        name: 'Giant Spider',
        tier: 1,
        img: 'monsters/giantSpiderMonster.png',
        description: 'Large arachnids that may ensnare players with webs.',
        stats: { health: 30, minDamage: 4, maxDamage: 7, hitChance: 0.65, defense: 1, xp: 20 },
        lootTable: { 'spiderSilk': { chance: 0.7, quantity: [1, 3] }, 'poisonGland': { chance: 0.4, quantity: [1, 1] }, 'spiderLeg': { chance: 0.2, quantity: [1, 4] } }
    },
    'caveBeetle': {
        key: 'caveBeetle',
        name: 'Cave Beetle',
        tier: 1,
        img: 'monsters/caveBeetleMonster.png',
        description: 'Slow-moving but heavily armored, making them resistant to early attacks.',
        stats: { health: 35, minDamage: 2, maxDamage: 4, hitChance: 0.6, defense: 4, xp: 18 },
        lootTable: { 'chitinShell': { chance: 0.8, quantity: [1, 2] }, 'insectGoo': { chance: 0.5, quantity: [1, 3] } }
    },
    'smallRockGolem': {
        key: 'smallRockGolem',
        name: 'Small Rock Golem',
        tier: 1,
        img: 'monsters/rockGolemMonster.png',
        description: 'Constructs made of earth and stone, resistant to blunt attacks.',
        stats: { health: 40, minDamage: 4, maxDamage: 8, hitChance: 0.55, defense: 5, xp: 25 },
        lootTable: { 'stone': { chance: 0.9, quantity: [5, 15] }, 'gemShards': { chance: 0.1, quantity: [1, 3] } }
    },

    // Tier 2: Iron & Deeper Underground (for copper weapons 8-10 damage)
    'armoredGoblin': {
        key: 'armoredGoblin',
        name: 'Armored Goblin',
        tier: 2,
        img: 'monsters/armoredGoblinMonster.png',
        description: 'Goblins wearing crude iron scraps for armor, making them significantly tougher.',
        stats: { health: 50, minDamage: 6, maxDamage: 10, hitChance: 0.65, defense: 4, xp: 35 },
        lootTable: { 'goblinEar': { chance: 0.7, quantity: [1, 3] }, 'steelScraps': { chance: 0.5, quantity: [1, 2] }, 'gold': { chance: 0.8, quantity: [10, 25] } }
    },
    'hobgoblinBasic': {
        key: 'hobgoblinBasic',
        name: 'Hobgoblin Scout',
        tier: 2,
        img: 'monsters/hobgoblinMonster.png',
        description: 'Larger and more intelligent than regular goblins, they coordinate attacks.',
        stats: { health: 60, minDamage: 7, maxDamage: 12, hitChance: 0.7, defense: 3, xp: 45 },
        lootTable: { 'goblinEar': { chance: 0.8, quantity: [1, 4] }, 'emeraldGem': { chance: 0.1, quantity: [1, 1] }, 'gold': { chance: 0.9, quantity: [15, 35] } }
    },
    'hobgoblinWarrior': {
        key: 'hobgoblinWarrior',
        name: 'Hobgoblin Warrior',
        tier: 2,
        img: 'monsters/hobgoblinMonster2.png',
        description: 'Well-armed hobgoblins, skilled in combat tactics and teamwork.',
        stats: { health: 70, minDamage: 8, maxDamage: 14, hitChance: 0.75, defense: 5, xp: 55 },
        lootTable: { 'goblinEar': { chance: 0.9, quantity: [2, 5] }, 'rubyGem': { chance: 0.12, quantity: [1, 1] }, 'ironBar': { chance: 0.1, quantity: [1, 1] } }
    },
    'hobgoblinEnforcer': {
        key: 'hobgoblinEnforcer',
        name: 'Hobgoblin Enforcer',
        tier: 2,
        img: 'monsters/hobgoblinMonster3.png',
        description: 'Heavily built hobgoblins that act as shock troops, wielding larger weapons.',
        stats: { health: 80, minDamage: 10, maxDamage: 16, hitChance: 0.65, defense: 6, xp: 65 },
        lootTable: { 'goblinEar': { chance: 0.9, quantity: [2,5] }, 'ironBar': { chance: 0.15, quantity: [1,1] }, 'steelScraps': {chance: 0.3, quantity: [1,3]} }
    },
    'caveBear': {
        key: 'caveBear',
        name: 'Cave Bear',
        tier: 2,
        img: 'monsters/caveBearMonster.png',
        description: 'A massive, ferocious beast inhabiting deeper caves. High health and damage.',
        stats: { health: 90, minDamage: 12, maxDamage: 18, hitChance: 0.6, defense: 3, xp: 75 },
        lootTable: { 'bearPelt': { chance: 0.6, quantity: [1, 1] }, 'bearClaw': { chance: 0.4, quantity: [1, 2] }, 'rawMeatLarge': { chance: 0.8, quantity: [1, 3] } }
    },
    'mediumIronGolem': {
        key: 'mediumIronGolem',
        name: 'Iron Golem (Medium)',
        tier: 2,
        img: 'monsters/ironGolemMonster.png',
        description: 'Larger golems, heavily resistant to physical damage. Requires strong hits to break.',
        stats: { health: 120, minDamage: 8, maxDamage: 14, hitChance: 0.5, defense: 10, xp: 100 },
        lootTable: { 'ironOre': { chance: 0.9, quantity: [3, 8] }, 'ironBar': { chance: 0.2, quantity: [1, 2] }, 'roughDiamond': { chance: 0.05, quantity: [1, 1] } }
    },

    // Tier 3: Steel & Fortified/Dangerous Zones (for iron weapons 15-18 damage)
    'banditThug': {
        key: 'banditThug',
        name: 'Bandit Thug',
        tier: 3,
        img: 'monsters/banditThugMonster.png',
        description: 'Humanoid enemies, often wielding steel weapons. May attack in groups.',
        stats: { health: 100, minDamage: 15, maxDamage: 22, hitChance: 0.75, defense: 6, xp: 90 },
        lootTable: { 'gold': { chance: 0.9, quantity: [20, 50] }, 'steelScraps': { chance: 0.6, quantity: [1, 3] }, 'bandage': { chance: 0.3, quantity: [1,2] } }
    },
    'banditRogue': {
        key: 'banditRogue',
        name: 'Bandit Rogue',
        tier: 3,
        img: 'monsters/banditRogueMonster.png',
        description: 'A nimble bandit, preferring quick strikes and evasion.',
        stats: { health: 85, minDamage: 18, maxDamage: 25, hitChance: 0.8, defense: 4, xp: 100 },
        lootTable: { 'gold': { chance: 0.8, quantity: [25, 60] }, 'silverDust': { chance: 0.1, quantity: [1,2] }, 'healingPotion': { chance: 0.05, quantity: [1,1] } }
    },
    'ogre': {
        key: 'ogre',
        name: 'Ogre',
        tier: 3,
        img: 'monsters/OgreMonster.png',
        description: 'A hulking, slow creature with immense strength. Its attacks deal heavy damage.',
        stats: { health: 180, minDamage: 20, maxDamage: 30, hitChance: 0.55, defense: 8, xp: 150 },
        lootTable: { 'coarseHide': { chance: 0.7, quantity: [2,4] }, 'boneLarge': { chance: 0.5, quantity: [1,2] } }
    },
    'youngGriffin': {
        key: 'youngGriffin',
        name: 'Young Griffin',
        tier: 3,
        img: 'monsters/youngGriffenMonster.png',
        description: 'Agile flying beasts with sharp talons. Can be difficult to hit without ranged options.',
        stats: { health: 120, minDamage: 16, maxDamage: 24, hitChance: 0.7, defense: 6, xp: 130 },
        lootTable: { 'griffinFeather': { chance: 0.8, quantity: [2,5] }, 'griffinClaw': { chance: 0.3, quantity: [1,2] }, 'toughHide': { chance: 0.4, quantity: [1,2] } }
    },
    'earthElemental': {
        key: 'earthElemental',
        name: 'Earth Elemental',
        tier: 3,
        img: 'monsters/earthElementalMonster.png',
        description: 'A creature formed from the earth, highly resistant to physical attacks but vulnerable to magical or specific weapon types.',
        stats: { health: 200, minDamage: 14, maxDamage: 20, hitChance: 0.6, defense: 15, xp: 170 },
        lootTable: { 'stone': { chance: 1.0, quantity: [20,50] }, 'silverOre': { chance: 0.1, quantity: [1,3] }, 'elementalCore': { chance: 0.05, quantity: [1,1] } }
    },

    // Tier 4: Precious Metals & Enchanted/Sacred Zones
    'ghost': {
        key: 'ghost',
        name: 'Ghost',
        tier: 4,
        img: 'monsters/ghostMonster.png',
        description: 'Ethereal beings that are difficult to hit with normal attacks; may drain energy or health.',
        stats: { health: 150, minDamage: 25, maxDamage: 40, hitChance: 0.65, defense: 5, xp: 200, ethereal: true },
        lootTable: { 'ectoplasm': { chance: 0.7, quantity: [1,3] }, 'spiritDust': { chance: 0.5, quantity: [2,4] }, 'silverDust': { chance: 0.2, quantity: [1,2] } }
    },
    'specter': {
        key: 'specter',
        name: 'Specter',
        tier: 4,
        img: 'monsters/specterMonster.png',
        description: 'A more malevolent and powerful spectral entity, often guarding forgotten relics.',
        stats: { health: 180, minDamage: 30, maxDamage: 45, hitChance: 0.7, defense: 8, xp: 230, ethereal: true },
        lootTable: { 'ectoplasm': { chance: 0.8, quantity: [2,4] }, 'spiritDust': { chance: 0.6, quantity: [3,5] }, 'darkEssence': { chance: 0.1, quantity: [1,1] } }
    },
    'lootGolem': {
        key: 'lootGolem',
        name: 'Loot Golem',
        tier: 4,
        img: 'monsters/lootGolemMonster.png',
        description: 'A rare and elusive golem made entirely of sparkling ore and gems. Tries to flee combat.',
        stats: { health: 100, minDamage: 5, maxDamage: 10, hitChance: 0.4, defense: 20, xp: 150, flees: true },
        lootTable: { 'gold': { chance: 1.0, quantity: [100, 300] }, 'goldOre': { chance: 0.8, quantity: [5,15] }, 'sapphireGem': { chance: 0.3, quantity: [1,2] }, 'rubyGem': { chance: 0.3, quantity: [1,2] }, 'emeraldGem': { chance: 0.3, quantity: [1,2] } }
    },
    'corruptedWerewolf': {
        key: 'corruptedWerewolf',
        name: 'Corrupted Werewolf',
        tier: 4,
        img: 'monsters/corruptedWerewolfMonster.png',
        description: 'A swift and savage beast, inflicting deep wounds and potentially curses (e.g., reduced healing).',
        stats: { health: 220, minDamage: 35, maxDamage: 55, hitChance: 0.8, defense: 15, xp: 280 },
        lootTable: { 'werewolfPelt': { chance: 0.4, quantity: [1,1] }, 'silverOre': { chance: 0.15, quantity: [1,3] }, 'lycanFangs': { chance: 0.2, quantity: [1,2] } }
    },
    'forestGuardian': {
        key: 'forestGuardian',
        name: 'Forest Guardian',
        tier: 4,
        img: 'monsters/forestGuardianMonster.png',
        description: 'An ancient and powerful plant-like creature, defending sacred groves. May summon roots to restrain players.',
        stats: { health: 400, minDamage: 30, maxDamage: 50, hitChance: 0.65, defense: 22, xp: 320 },
        lootTable: { 'enchantedWood': { chance: 0.7, quantity: [3,7] }, 'purePlantFibers': { chance: 0.5, quantity: [5,10] }, 'ancientSap': { chance: 0.2, quantity: [1,2] }, 'magicalGem': { chance: 0.05, quantity: [1,1] } }
    },

    // Tier 5: Magical/Exotic Metals & Deepest Dungeons/Volcanic Lairs
    'dragonkinWhelp': {
        key: 'dragonkinWhelp',
        name: 'Dragonkin Whelp',
        tier: 5,
        img: 'monsters/dragonkinWhelpMonster.png',
        description: 'A young, but still dangerous, dragon-like creature capable of breathing elemental fire.',
        stats: { health: 350, minDamage: 40, maxDamage: 60, hitChance: 0.7, defense: 18, xp: 400 },
        lootTable: { 'dragonScale': { chance: 0.8, quantity: [2,5] }, 'dragonTooth': { chance: 0.3, quantity: [1,2] }, 'elementalHeart': { chance: 0.1, quantity: [1,1] } }
    },
    'abyssalHorror': {
        key: 'abyssalHorror',
        name: 'Abyssal Horror',
        tier: 5,
        img: 'monsters/abyssalHorrorMonster.png',
        description: 'A monstrous creature from unimaginable depths, with multiple tentacles and corrosive attacks.',
        stats: { health: 500, minDamage: 50, maxDamage: 75, hitChance: 0.6, defense: 25, xp: 550 },
        lootTable: { 'abyssalTentacle': { chance: 0.05, quantity: [1,1] }, 'darkEssence': { chance: 0.4, quantity: [1,3] }, 'voidShard': { chance: 0.2, quantity: [1,2] } }
    },
    'ancientGolem': {
        key: 'ancientGolem',
        name: 'Ancient Golem',
        tier: 5,
        img: 'monsters/ancientGolemMonster.png',
        description: 'An enormous, ancient golem made of Mythril and Adamantite, nearly impervious to physical damage.',
        stats: { health: 800, minDamage: 45, maxDamage: 65, hitChance: 0.5, defense: 40, xp: 700 },
        lootTable: { 'mythrilOre': { chance: 0.7, quantity: [3,6] }, 'adamantiteOre': { chance: 0.5, quantity: [2,4] }, 'golemCore': { chance: 0.02, quantity: [1,1] } }
    },
    'shadowLurker': {
        key: 'shadowLurker',
        name: 'Shadow Lurker',
        tier: 5,
        img: 'monsters/shadowLurker.png',
        description: 'A creature of pure shadow, nearly invisible and capable of devastating surprise attacks.',
        stats: { health: 300, minDamage: 60, maxDamage: 90, hitChance: 0.85, defense: 15, xp: 600 },
        lootTable: { 'shadowCloth': { chance: 0.6, quantity: [1,3] }, 'darkSoulShard': { chance: 0.3, quantity: [1,2] }, 'mythrilOre': { chance: 0.05, quantity: [1,1] } }
    },
    // === Tier 1: Gloomwood Forest Outskirts ===
    "gloomfangWolfPup": {
        key: "gloomfangWolfPup",
        name: "Gloomfang Wolf Pup",
        tier: 1,
        img: "monsters/tier1_gloomfang_wolf_pup_icon.png",
        description: "Young, but already showing the characteristic aggression of its pack. Its yips are surprisingly sharp.",
        stats: { health: 20, minDamage: 3, maxDamage: 6, hitChance: 0.7, defense: 1, xp: 8 },
        lootTable: {
            "wolfPeltScraps": { chance: 0.6, quantity: [1, 1], icon: "loot/wolf_pelt_scraps_icon.png" },
            "smallAnimalBone": { chance: 0.4, quantity: [1, 2], icon: "loot/small_animal_bone_icon.png" }
        },
        isBoss: false,
        specialMechanics: "None, but often appears in small groups (2-3)."
    },
    "shadowSprite": {
        key: "shadowSprite",
        name: "Shadow Sprite",
        tier: 1,
        img: "monsters/tier1_shadow_sprite_icon.png",
        description: "A mischievous fey creature that flits through the dim light, hard to hit and fond of minor illusions.",
        stats: { health: 15, minDamage: 2, maxDamage: 4, hitChance: 0.65, defense: 3, xp: 10 },
        lootTable: {
            "glimmeringDust": { chance: 0.5, quantity: [1, 1], icon: "loot/glimmering_dust_icon.png" },
            "nightshadePetal": { chance: 0.2, quantity: [1, 1], icon: "loot/nightshade_petal_icon.png" }
        },
        isBoss: false,
        specialMechanics: "High Evasion: Player attacks against it have a reduced hit chance unless the player has high Dexterity or a special item."
    },
    "twistedSapling": {
        key: "twistedSapling",
        name: "Twisted Sapling",
        tier: 1,
        img: "monsters/tier1_twisted_sapling_icon.png",
        description: "A young tree animated by dark forest magic, lashing out with thorny branches.",
        stats: { health: 30, minDamage: 4, maxDamage: 7, hitChance: 0.6, defense: 2, xp: 12 },
        lootTable: {
            "gnarledWood": { chance: 0.7, quantity: [1, 3], icon: "loot/gnarled_wood_icon.png" },
            "livingSap": { chance: 0.3, quantity: [1, 1], icon: "loot/living_sap_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Root Grab: Chance to briefly immobilize the player."
    },
    "goblinForager": {
        key: "goblinForager",
        name: "Goblin Forager",
        tier: 1,
        img: "monsters/tier1_goblin_forager_icon.png",
        description: "A scrawny goblin, more interested in pilfering than fighting, but will defend its scavenged goods.",
        stats: { health: 25, minDamage: 3, maxDamage: 5, hitChance: 0.65, defense: 0, xp: 9 },
        lootTable: {
            "brokenTrinket": { chance: 0.5, quantity: [1, 1], icon: "loot/broken_trinket_icon.png" },
            "moldyBerries": { chance: 0.4, quantity: [1, 2], icon: "loot/moldy_berries_icon.png" },
            "gold": { chance: 0.1, quantity: [5, 15] } // Using 'gold' key directly for gold
        },
        isBoss: false,
        specialMechanics: "Scavenge: If not attacked for a few turns, might try to steal a minor item."
    },
    "giantForestSpider": {
        key: "giantForestSpider",
        name: "Giant Forest Spider",
        tier: 1,
        img: "monsters/tier1_giant_forest_spider_icon.png",
        description: "An unpleasantly large arachnid that lurks in the shadowed parts of the woods.",
        stats: { health: 35, minDamage: 5, maxDamage: 8, hitChance: 0.7, defense: 1, xp: 15 },
        lootTable: {
            "spiderSilkThread": { chance: 0.8, quantity: [1, 3], icon: "loot/spider_silk_thread_icon.png" },
            "spiderVenomGland": { chance: 0.25, quantity: [1, 1], icon: "loot/spider_venom_gland_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Web Shot: Chance to slow the player's attack speed."
    },
    "gloomwoodBanditScout": {
        key: "gloomwoodBanditScout",
        name: "Gloomwood Bandit Scout",
        tier: 1,
        img: "monsters/tier1_gloomwood_bandit_scout_icon.png",
        description: "A lightly armed bandit keeping an eye out for unwary travelers. Prefers a quick strike and retreat if outnumbered.",
        stats: { health: 30, minDamage: 4, maxDamage: 7, hitChance: 0.7, defense: 2, xp: 14 },
        lootTable: {
            "gold": { chance: 0.6, quantity: [3, 10] },
            "crudeDagger": { chance: 0.15, quantity: [1, 1], icon: "loot/crude_dagger_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Alert: If not defeated quickly, might 'call for help'."
    },
    "krellGloomfangAlpha": {
        key: "krellGloomfangAlpha",
        name: "Krell, the Gloomfang Alpha",
        tier: 1,
        img: "monsters/tier1_krell_gloomfang_alpha_icon.png",
        description: "A large, scarred wolf with eyes that burn with a faint, unsettling light. Leader of the Gloomfang pups.",
        stats: { health: 80, minDamage: 8, maxDamage: 15, hitChance: 0.75, defense: 3, xp: 50 },
        lootTable: {
            "alphaWolfPelt": { chance: 1.0, quantity: [1, 1], icon: "loot/alpha_wolf_pelt_icon.png" },
            "krellsTooth": { chance: 0.5, quantity: [1, 1], icon: "loot/krells_tooth_icon.png" },
            "forestHeartRuby": { chance: 0.1, quantity: [1, 1], icon: "loot/forest_heart_ruby_icon.png" }
        },
        isBoss: true,
        encounterGroupKey: "gloomwood_tier1_wave",
        specialMechanics: "Howl of Command: Buffs allies. Frenzied Strikes: Increased attacks at low health. Unlocks Tier 2."
    },

    // === Tier 2: The Murkwater Caves ===
    "giantCaveCrab": {
        key: "giantCaveCrab",
        name: "Giant Cave Crab",
        tier: 2,
        img: "monsters/tier2_giant_cave_crab_icon.png",
        description: "A heavily armored crustacean with powerful claws, scuttling sideways to defend its damp territory.",
        stats: { health: 50, minDamage: 6, maxDamage: 10, hitChance: 0.65, defense: 5, xp: 25 },
        lootTable: {
            "crabChitinFragment": { chance: 0.7, quantity: [1, 2], icon: "loot/crab_chitin_fragment_icon.png" },
            "crabMeat": { chance: 0.5, quantity: [1, 1], icon: "loot/crab_meat_icon.png" },
            "smallPearl": { chance: 0.05, quantity: [1, 1], icon: "loot/small_pearl_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Pincer Crush: Chance for extra damage or Bleed."
    },
    "murkwaterSalamander": {
        key: "murkwaterSalamander",
        name: "Murkwater Salamander",
        tier: 2,
        img: "monsters/tier2_murkwater_salamander_icon.png",
        description: "A slick-skinned amphibian that can spit a blinding slime and regenerate minor wounds.",
        stats: { health: 40, minDamage: 5, maxDamage: 9, hitChance: 0.7, defense: 2, xp: 22 },
        lootTable: {
            "salamanderHide": { chance: 0.6, quantity: [1, 1], icon: "loot/salamander_hide_icon.png" },
            "stickySlimeGlob": { chance: 0.4, quantity: [1, 2], icon: "loot/sticky_slime_glob_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Slime Spit: Reduces player hit chance. Regeneration."
    },
    "deepLurkerBat": {
        key: "deepLurkerBat",
        name: "Deep Lurker Bat",
        tier: 2,
        img: "monsters/tier2_deep_lurker_bat_icon.png",
        description: "Larger and more vicious than its forest cousins, this bat uses echolocation to navigate and attack in total darkness.",
        stats: { health: 30, minDamage: 7, maxDamage: 11, hitChance: 0.75, defense: 1, xp: 20 },
        lootTable: {
            "largeBatWing": { chance: 0.7, quantity: [1, 2], icon: "loot/large_bat_wing_icon.png" },
            "guanoPile": { chance: 0.3, quantity: [1, 1], icon: "loot/guano_pile_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Sonic Shriek: Area attack, can disorient."
    },
    "caveGoblinThug": {
        key: "caveGoblinThug",
        name: "Cave Goblin Thug",
        tier: 2,
        img: "monsters/tier2_cave_goblin_thug_icon.png",
        description: "Tougher goblins adapted to cave life, wielding crude stone weapons with surprising force.",
        stats: { health: 45, minDamage: 6, maxDamage: 10, hitChance: 0.7, defense: 3, xp: 28 },
        lootTable: {
            "chippedStoneAxe": { chance: 0.2, quantity: [1, 1], icon: "loot/chipped_stone_axe_icon.png" },
            "glowingMushroom": { chance: 0.4, quantity: [1, 2], icon: "loot/glowing_mushroom_icon.png" },
            "ironOreChunk": { chance: 0.1, quantity: [1, 1], icon: "loot/iron_ore_chunk_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Cave Camouflage: Higher ambush chance in caves."
    },
    "slitheringCaveEel": {
        key: "slitheringCaveEel",
        name: "Slithering Cave Eel",
        tier: 2,
        img: "monsters/tier2_slithering_cave_eel_icon.png",
        description: "A long, slippery eel that can constrict its prey or deliver a shocking jolt.",
        stats: { health: 38, minDamage: 5, maxDamage: 8, hitChance: 0.68, defense: 2, xp: 24 },
        lootTable: {
            "eelSkin": { chance: 0.6, quantity: [1, 1], icon: "loot/eel_skin_icon.png" },
            "bioelectricOrgan": { chance: 0.2, quantity: [1, 1], icon: "loot/bioelectric_organ_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Constrict: Holds player. Shocking Jolt: Electric damage, chance to stun."
    },
    "basiliskHatchling": {
        key: "basiliskHatchling",
        name: "Stone-Skinned Basilisk Hatchling",
        tier: 2,
        img: "monsters/tier2_basilisk_hatchling_icon.png",
        description: "A young basilisk whose gaze isn't fully petrifying yet, but can cause temporary stiffness and discomfort.",
        stats: { health: 60, minDamage: 7, maxDamage: 12, hitChance: 0.6, defense: 6, xp: 35 },
        lootTable: {
            "basiliskScale": { chance: 0.5, quantity: [1, 2], icon: "loot/basilisk_scale_icon.png" },
            "unhatchedBasiliskEgg": { chance: 0.1, quantity: [1, 1], icon: "loot/unhatched_basilisk_egg_icon.png" }
        },
        isBoss: false,
        specialMechanics: "Petrifying Gaze (Minor): Chance to inflict Slow or Reduced Dexterity."
    },
    "murkwaterMatriarch": {
        key: "murkwaterMatriarch",
        name: "The Murkwater Matriarch",
        tier: 2,
        img: "monsters/tier2_murkwater_matriarch_icon.png",
        description: "An enormous, ancient spider queen residing in the deepest, darkest parts of the Murkwater Caves. Her fangs drip with potent venom, and her webs are legendary.",
        stats: { health: 150, minDamage: 10, maxDamage: 18, hitChance: 0.75, defense: 4, xp: 100 },
        lootTable: {
            "matriarchsHeart": { chance: 1.0, quantity: [1, 1], icon: "loot/matriarchs_heart_icon.png" },
            "ichorOfVenom": { chance: 0.7, quantity: [1, 2], icon: "loot/ichor_of_venom_icon.png" },
            "ancientSpiderFang": { chance: 0.3, quantity: [1, 1], icon: "loot/ancient_spider_fang_icon.png" },
            "caveCrystalCluster": { chance: 0.15, quantity: [1, 1], icon: "loot/cave_crystal_cluster_icon.png" }
        },
        isBoss: true,
        encounterGroupKey: "murkwater_tier2_wave",
        specialMechanics: "Summon Spiderlings. Ensnaring Web Barrage. Toxic Bite. Unlocks Tier 3."
    },
    // ... (Tiers 3-8 would go here when you're ready for them)
};

// Monster progression requirements
export const MonsterProgression = {
    // Tier 0 - All unlocked by default
    'slime': { unlocked: true },
    'forestBat': { unlocked: true },
    'wildBoar': { requires: 'slime', killCount: 5 },
    'wolfPup': { requires: 'wildBoar', killCount: 3 },
    
    // Tier 1 - Unlocked after meeting T0 requirements
    'goblinBasic': { requires: 'wolfPup', killCount: 5 },
    'goblinWarrior': { requires: 'goblinBasic', killCount: 4 },
    'giantSpider': { requires: 'goblinWarrior', killCount: 3 },
    'caveBeetle': { requires: 'giantSpider', killCount: 3 },
    'smallRockGolem': { requires: 'caveBeetle', killCount: 2 },
    'gloomfangWolfPup': { requires: 'smallRockGolem', killCount: 2 },
    'shadowSprite': { requires: 'gloomfangWolfPup', killCount: 3 },
    'twistedSapling': { requires: 'shadowSprite', killCount: 3 },
    'goblinForager': { requires: 'twistedSapling', killCount: 2 },
    'giantForestSpider': { requires: 'goblinForager', killCount: 3 },
    'gloomwoodBanditScout': { requires: 'giantForestSpider', killCount: 2 },
    'krellGloomfangAlpha': { requires: 'gloomwoodBanditScout', killCount: 2, isTierBoss: true },
    
    // Tier 2 - Unlocked after Tier 1 boss
    'armoredGoblin': { requires: 'krellGloomfangAlpha', killCount: 1, isBossUnlock: true },
    'hobgoblinBasic': { requires: 'armoredGoblin', killCount: 4 },
    'hobgoblinWarrior': { requires: 'hobgoblinBasic', killCount: 3 },
    'hobgoblinEnforcer': { requires: 'hobgoblinWarrior', killCount: 3 },
    'caveBear': { requires: 'hobgoblinEnforcer', killCount: 2 },
    'mediumIronGolem': { requires: 'caveBear', killCount: 2 },
    'giantCaveCrab': { requires: 'mediumIronGolem', killCount: 2 },
    'murkwaterSalamander': { requires: 'giantCaveCrab', killCount: 3 },
    'deepLurkerBat': { requires: 'murkwaterSalamander', killCount: 3 },
    'caveGoblinThug': { requires: 'deepLurkerBat', killCount: 3 },
    'slitheringCaveEel': { requires: 'caveGoblinThug', killCount: 2 },
    'basiliskHatchling': { requires: 'slitheringCaveEel', killCount: 2 },
    'murkwaterMatriarch': { requires: 'basiliskHatchling', killCount: 2, isTierBoss: true },
    
    // Tier 3 - Unlocked after Tier 2 boss  
    'banditThug': { requires: 'murkwaterMatriarch', killCount: 1, isBossUnlock: true },
    'banditRogue': { requires: 'banditThug', killCount: 4 },
    'ogre': { requires: 'banditRogue', killCount: 3 },
    'youngGriffin': { requires: 'ogre', killCount: 2 },
    'earthElemental': { requires: 'youngGriffin', killCount: 2 },
    
    // Additional tiers would continue this pattern...
};

// Function to check if a monster is unlocked for the player
export function isMonsterUnlocked(monsterKey, playerKillCounts) {
    const progression = MonsterProgression[monsterKey];
    if (!progression) return false;
    
    // If unlocked by default (early monsters)
    if (progression.unlocked) return true;
    
    // Check if required monster has been killed enough times
    if (progression.requires && progression.killCount) {
        const requiredKills = playerKillCounts[progression.requires] || 0;
        return requiredKills >= progression.killCount;
    }
    
    return false;
}

// Function to get unlock requirements for display
export function getUnlockRequirement(monsterKey) {
    const progression = MonsterProgression[monsterKey];
    if (!progression || progression.unlocked) return null;
    
    if (progression.requires && progression.killCount) {
        const requiredMonster = MonsterData[progression.requires];
        return {
            requiredMonsterKey: progression.requires,
            monsterName: requiredMonster?.name || progression.requires,
            killCount: progression.killCount,
            isTierBoss: progression.isTierBoss || false,
            isBossUnlock: progression.isBossUnlock || false
        };
    }
    
    return null;
}

// Function to get available monsters (you might already have this or similar)
export function getAvailableMonstersByTier(tier) {
    return Object.values(MonsterData).filter(monster => monster.tier === tier);
}

export function getAllMonstersForDisplay() {
    // This function can be used by WildernessActionsPanel if it needs a flat list first
    return Object.values(MonsterData).map(m => ({
        key: m.key,
        name: m.name,
        tier: m.tier,
        imgPath: m.img, // Ensure WildernessActionsPanel uses imgPath or adapt this
        isBoss: m.isBoss || false,
    }));
}
